import React from 'react';
import { CTAButton } from '../CTAButton';
import { recognizeItems } from '../../data/content';
export function Recognize() {
  return <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="recognize-title" data-id="element-278" data-mp="6mcs7hjiku7o">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-279" data-mp="3p02iajr4wskq">
        <h2 id="recognize-title" className="text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-ink-900 sm:text-4xl" data-id="element-280" data-mp="3t275p0qzosyx">
          Do you recognize yourself in any of these?
        </h2>
        <p className="mt-3 text-center text-[15px] font-semibold text-ink-700 sm:text-lg" data-id="element-281" data-mp="3k3c1fu7i9sy9">
          If you answer YES to even one, this system was created for you.
        </p>

        <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-282" data-mp="3a4mgfskbbsds">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl border border-ink-900/10 bg-white p-4" data-id="element-283" data-mp="14bo808rpaik7">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-284" data-mp="1ig8r6i1a454e">
                {item.emoji}
              </span>
              <span className="text-sm font-medium leading-snug text-ink-800 sm:text-base" data-id="element-285" data-mp="1dhxjacujo4ot">
                {item.text}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl bg-ink-950 p-5 sm:p-7" data-id="element-286" data-mp="1n78pnrq1qv90">
          <h3 className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-gold-500 sm:text-3xl" data-id="element-287" data-mp="1n91wb70ntfh0">
            And it shouldn’t be this way.
          </h3>
          <div className="mt-4 space-y-2.5 text-center text-[15px] leading-relaxed text-steel-300 sm:text-base" data-id="element-288" data-mp="ujuo1gbelbik">
            <p data-id="element-289" data-mp="19dhd0ah0qv92">Because the problem isn’t your technical ability.</p>
            <p data-id="element-290" data-mp="14fo8rmza0bbf">You were taught how to repair appliances.</p>
            <p className="font-semibold text-white" data-id="element-291" data-mp="2kuh4j3vjl621">
              Nobody taught you how to package, present, and operate your repair
              service like a professional business.
            </p>
            <p data-id="element-292" data-mp="2mz2wgkx94gz5">
              That’s exactly what the Premium Technician Kit™ is designed to solve.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-293" data-mp="2rwcjjtx64gjt">
          <CTAButton label="I want the professional system" sub="Instant download · Lifetime access" size="md" data-id="element-294" data-mp="2wxa0622j52j7" />
        </div>
      </div>
    </section>;
}